import { render, staticRenderFns } from "./TermsManagement.vue?vue&type=template&id=4dd46f0a&scoped=true&"
import script from "./TermsManagement.vue?vue&type=script&lang=js&"
export * from "./TermsManagement.vue?vue&type=script&lang=js&"
import style0 from "./TermsManagement.vue?vue&type=style&index=0&id=4dd46f0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd46f0a",
  null
  
)

export default component.exports